import React from "react";
import Icon from "../atoms/Icon";

const InputGroup = ({
  label,
  val,
  iconName,
  onchange,
  id,
  placeholder,
  onFocus,
  readOnly,
  width,
  disabled,
  type,
  value,
  icon,
  onchangeAble,
  name,
  AddClass,
  direction,
  divdir
}) => {
  return (
    <div className={`flex flex-col w-full ${width}`}>
      {/* Label */}
      <label
        htmlFor={id} // Use id prop for htmlFor attribute
        className="text-dark-blue-200 text-12 font-normal leading-5 mb-2.5"
      >
        {label}
      </label>
      
      {/* Render input with or without icon based on 'icon' prop */}
      {icon === false ? (
        <>
          {/* Input without icon */}
          <div className="flex flex-row bg-gray-chart-200 w-full px-3.5 gap-2.5 items-center rounded-sm h-12.6">
            {/* Check if input should be editable */}
            {onchangeAble === true ? (
              // Editable input
              <input
                onFocus={onFocus}
                name={name}
                id={id}
                type={type}
                placeholder={placeholder}
                className={`bg-gray-chart-200 outline-none text-dark-blue-200 text-13 py-3.5 w-full ${AddClass}`}
                defaultValue={val}
                onChange={onchange}
                disabled={disabled}
                dir={direction}
              />
            ) : (
              // Read-only input
              <input
                readOnly={true}
                onFocus={onFocus}
                id={id}
                type={type}
                placeholder={placeholder}
                className={`bg-gray-chart-200 outline-none text-dark-blue-200 text-13 py-3.5 w-full ${AddClass}`}
                value={value}
                dir={direction}
              />
            )}
          </div>
        </>
      ) : (
        <>
          {/* Input with icon */}
          <div className="flex flex-row bg-gray-chart-200 w-full px-3.5 gap-2.5 items-center rounded-sm h-12.6" dir={divdir}>
            {/* Icon */}
            <Icon iconName={iconName} />
            {/* Check if input should be editable */}
            {onchange ? (
              // Editable input
              <input
                readOnly={readOnly ? true : false}
                onFocus={onFocus}
                id={id}
                type={type}
                placeholder={placeholder}
                className={`bg-gray-chart-200 outline-none text-dark-blue-200 text-13 py-3.5 w-full ${AddClass} `}
                defaultValue={val}
                onChange={onchange}
                disabled={disabled}
                dir={direction}
              />
            ) : (
              // Read-only input
              <input
                readOnly={true}
                onFocus={onFocus}
                id={id}
                type={type}
                placeholder={placeholder}
                className={`bg-gray-chart-200 outline-none text-dark-blue-200 text-13 py-3.5 w-full ${AddClass}`}
                dir={direction}
                value={value}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default InputGroup;
